<template>
  <div class="col-12 mt-3">
    <fg-input type="password" :label="$t('message.New Password')" :placeholder="$t('message.New Password')" v-model="passwordDetails.newPassword"></fg-input>
    <fg-input type="password" :label="$t('message.Verify Password')" :placeholder="$t('message.Verify Password')" v-model="passwordDetails.verifyPassword"></fg-input>
    <div class="col-12 text-center">
      <n-button type="primary" round @click.native="changePassword()">{{ $t('message.Change Password')}}</n-button>
    </div>
    <div class="col-12 text-center text-danger">{{ errorMessage }}</div>
    <div v-if="settings.passwordPolicy && settings.passwordPolicy.enabled" class="mt-3">
      <ul style="font-size: smaller">
        <li ng-if="settings.passwordPolicy.minLength" :class="passwordValidationErrors.indexOf('minLength') > -1 ? 'text-danger' : ''">
          <span>{{$t('message.Should contain at least 1 digit')}} {{ settings.passwordPolicy.minLength }} {{$t('message. characters')}}</span>
        </li>
        <li ng-if="settings.passwordPolicy.maxLength" :class="passwordValidationErrors.indexOf('maxLength') > -1 ? 'text-danger' : ''">
          <span>{{$t('message.Should contain at most')}} {{ settings.passwordPolicy.maxLength }} {{$t('message. characters')}}</span>
        </li>
        <li ng-if="settings.passwordPolicy.digits" :class="passwordValidationErrors.indexOf('digits') > -1 ? 'text-danger' : ''">
          <span>{{$t('message.Should contain at least 1 digit')}} </span>
        </li>
        <li ng-if="settings.passwordPolicy.letters" :class="passwordValidationErrors.indexOf('letters') > -1 ? 'text-danger' : ''">
          <span>{{$t('message.Should contain at least 1 letter')}} </span>
        </li>
        <li ng-if="settings.passwordPolicy.uppercase" :class="passwordValidationErrors.indexOf('uppercase') > -1 ? 'text-danger' : ''">
          <span>{{$t('message.Should contain at least 1 uppercase letter')}} </span>
        </li>
        <li ng-if="settings.passwordPolicy.lowercase" :class="passwordValidationErrors.indexOf('lowercase') > -1 ? 'text-danger' : ''">
          <span>{{$t('message.Should contain at least 1 lowercase letter')}}</span>
        </li>
        <li ng-if="settings.passwordPolicy.symbols" :class="passwordValidationErrors.indexOf('symbols') > -1 ? 'text-danger' : ''">
          <span>{{$t('message.Should contain at least 1 symbol')}} </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "should-change-password",

  data() {
    return {
      passwordDetails: {
        newPassword: null,
        verifyPassword: null,
      },
      passwordValidationErrors: [],
      errorMessage: null,
    };
  },

  computed: {
    settings() {
      return this.$store.state.settings;
    },
  },

  beforeDestroy() {
    this.$store.commit("setState", {
      stateName: "shouldChangePasswordUser",
      stateValue: {},
    });
  },

  methods: {
    async changePassword() {
      try {
        let data = {
          userId: this.$store.state.shouldChangePasswordUser.userId,
          tenant: this.$store.state.shouldChangePasswordUser.tenantName,
          passwordDetails: {
            currentPassword:
              this.$store.state.shouldChangePasswordUser.password,
            newPassword: this.passwordDetails.newPassword,
            verifyPassword: this.passwordDetails.verifyPassword,
          },
        };
        await this.$store.dispatch("shouldChangePassword", data);
        this.errorMessage = "";
        this.passwordDetails = {
          newPassword: null,
          verifyPassword: null,
        };
        this.passwordValidationErrors = [];

        swal.fire({
          title: this.$t("message.Password changed successfully"),
          type: "success",
          timer: 3000,
        });

        this.$router.push("signin");
      } catch (e) {
        this.errorMessage = e.message;

        if (e.failedValidations && e.failedValidations.length > 0) {
          this.passwordValidationErrors = e.failedValidations;
        } else {
          this.passwordValidationErrors = [];
        }
      }
    },
  },
};
</script>
